import {inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {AttachData, BaseCustomerProps, CustomerData} from "../types/customer-modal.types";
import {map, Observable, switchMap} from "rxjs";
import {baseUrl} from "../../../../constants/base-url";
import {customerResourceType} from "../configs/customer-modal-config";

@Injectable({
  providedIn: 'root'
})
export class CustomerModalApiService {
  private http = inject(HttpClient);

  public getCustomerData(id: number): Observable<CustomerData> {
    return this.http.get<CustomerData>(`${baseUrl}/${customerResourceType.path}/${id}`);
  }

  public createCustomer(baseCustomerProms: BaseCustomerProps, feedbackId: number): Observable<CustomerData> {
    return this.http.post<CustomerData>(`${baseUrl}/${customerResourceType.path}`, baseCustomerProms).pipe(
      switchMap((customerData: CustomerData) => {
        return this.attachCustomer({
          id: customerData.id,
          feedbackId: feedbackId
        }).pipe(
          map(() => customerData)
        )
      })
    );
  }

  public attachCustomer(attachData: AttachData): Observable<void> {
    return this.http.post<void>(`${baseUrl}/${customerResourceType.path}/attach`, {}, {
      params: attachData
    });
  }

  public detachCustomer(feedbackId: number): Observable<void> {
    return this.http.post<void>(`${baseUrl}/${customerResourceType.path}/detach`, {}, {
      params: {
        feedbackId: feedbackId
      }
    });
  }
}
